AgrimarketControllers.controller('grainbowController', [
    '$scope', '$location', '$rootScope', 'grainbowService', 'enumFactory', 'configurationFactory', function ($scope, $location, $rootScope, grainbowService, enumFactory, configurationFactory) {

        $scope.logingrainbowErrorMessage = "";
        $rootScope.AuthorizedGrainbow = false;
        $rootScope.skin = configurationFactory.Skin;
        $rootScope.loading = false;

        if ($location.protocol().indexOf("https") !== -1) {
            for (var url in configurationFactory.Url) {
                configurationFactory.Url[url] = configurationFactory.Url[url].replace("http:", "https:");
            }
        }

        var host = $location.host();
        var port = $location.port();
        var protocol = $location.protocol();
        $scope.redirectUri =
            protocol + "://" +
            host +
            (host === "localhost" && port ? ":" + port : "") +
            "/loginGrainbowEntraID.html";

        $scope.GoToGrainbowEntraID = function () {
            $rootScope.loading = true;
            grainbowService.GetGrainbowEntraIDConfig(function (data, status) {
                if (status) {
                    $scope.logingrainbowErrorMessage = "Erreur lors de la récupération de la configuration Entra ID";
                    $rootScope.loading = false;
                } else {
                    window.location.href = "https://login.microsoftonline.com/" +
                        data.TenantId +
                        "/oauth2/v2.0/authorize?client_id=" + data.ClientId +
                        "&response_type=code&redirect_uri=" + encodeURIComponent($scope.redirectUri) +
                        "&scope=openid&nonce=AAAA&response_mode=query";
                }
            });
        };

    }]);
